// extracted by mini-css-extract-plugin
export default {"price":"j8-z","onSale":"k8-z","msrpLabelPrice":"l8-z","msrpLabel":"m8-z","originalPrice":"n8-z","percentOff":"o8-z"};